import React, { useState } from "react";
import styles from "../ai/TalkToAI.module.css";

export const API_BASE = process.env.BASE_URL;

export default function TalkToAI() {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!input.trim()) return;

    //Add a users message
    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);

    const currentInput = input;
    setInput("");
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/api/generate-text`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ input: currentInput }),
      });

      const data = await response.text();
      //Add AI's response
      setMessages((prev) => [...prev, { sender: "ai", text: data }]);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { sender: "ai", text: "Error connection to AI service." },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.header}>Talk to AI</h2>

      <div className={styles.chatArea}>
        {messages.map((msg, index) => (
          <div
            key={index}
            className={
              msg.sender === "user" ? styles.userBubble : styles.aiBubble
            }
          >
            {msg.text}
          </div>
        ))}
        {loading && <div className={styles.loading}>Thinking...</div>}
      </div>

      <textarea
        className={styles.textarea}
        rows="3"
        placeholder="Ask something...."
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <button className={styles.button} onClick={handleSend} disabled={loading}>
        {loading ? "Please wait..." : "Send"}
      </button>
    </div>
  );
}
